import { fetcher } from '@commenda/utils';
import { ServiceRequestEntityType } from '@prisma/client';
import { API_BASE_PATH } from '../constants';

export async function createServiceRequestIssue({
  data,
}: {
  data: {
    message: string;
    entityType: ServiceRequestEntityType;
    entityId: string;
    serviceRequestId: string;
  };
}) {
  const res = await fetcher(`${API_BASE_PATH}/issue`, {
    method: 'POST',
    body: data,
  });

  if (!res.ok) return false;

  return true;
}
